var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-modal",class:_vm.activeModal.name,on:{"mousedown":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"close",on:{"click":_vm.onClickClose}},[_c('UIIcon',{attrs:{"name":['fal', 'times']}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }